if (!customElements.get('piecework-gift-box-remove')) {
  customElements.define(
    'piecework-gift-box-remove',
    class PieceworkGiftBoxRemove extends HTMLElement {
      constructor() {
        super();
        this.cartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.cart = document.querySelector('cart-drawer-items');

        this.removeButton = this.querySelector('.cart-remove-wrapping');
      }

      async removeBoxes() {
        this.cart.enableLoading(null);
        await removeGiftBoxes();
        const body = JSON.stringify({
          attributes: {
            'Gift wrap': null,
          },
          sections: this.cart.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_update_url}`, {
          ...fetchConfig(),
          ...{ body },
        })
          .then((response) => response.json())
          .then((updateState) => {
            this.cart.getSectionsToRender().forEach((section) => {
              const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) ||
                document.getElementById(section.id);
              elementToReplace.innerHTML = this.cartDrawer.getSectionInnerHTML(
                updateState.sections[section.section],
                section.selector
              );
            });
          })
          .finally(() => {
            this.cart.disableLoading(null);
          });
      }

      connectedCallback() {
        this.removeButton.addEventListener('click', () => {
          console.log('ckucjed');
          this.removeBoxes();
        });
      }
    }
  );
}
